import { Mail, MessageCircle, Phone, Send } from 'lucide-react';
import type { ChannelKind } from '../hooks/useLeadForm';

export interface ChannelChipProps {
  kind: ChannelKind;
  label: string;
  active: boolean;
  onToggle: (kind: ChannelKind) => void;
}

const ICONS: Record<ChannelKind, typeof Send> = {
  telegram: Send,
  whatsapp: MessageCircle,
  phone: Phone,
  email: Mail,
};

export default function ChannelChip({ kind, label, active, onToggle }: ChannelChipProps) {
  const Icon = ICONS[kind];
  return (
    <button
      type="button"
      role="checkbox"
      aria-checked={active}
      onClick={() => onToggle(kind)}
      className={['lead-form__chip', `lead-form__chip--${kind}`, active ? 'lead-form__chip--active' : ''].filter(Boolean).join(' ')}
    >
      <span className="lead-form__chip-icon" aria-hidden="true"><Icon size={16} /></span>
      <span className="lead-form__chip-label">{label}</span>
    </button>
  );
}
